import Splide from '@splidejs/splide';

var main = new Splide( '#main-slider', {
  type       : 'fade',
  pagination : true,
  arrows     : true,
  cover      : true,
  rewind : true,
  drag: true,
} );

//var thumbnails = new Splide( '#thumbnail-slider', {
//  rewind          : true,
//  fixedWidth      : 104,
//  isNavigation    : true,
//  gap             : 0,
//  focus           : 'center',
//  pagination      : false,
//  cover           : true,
//  dragMinThreshold: {
//    mouse: 4,
//    touch: 10,
//  },
//  breakpoints : {
//    640: {
//      fixedWidth  : 60,
//    },
//  },
//} );

//main.sync( thumbnails );
main.mount();
//thumbnails.mount();
